module.exports = __webpack_public_path__ + "img/appointment@2x.64dd341.jpg";